import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services';

/**
 *  Guard to prevent navigation to routes that require authentication.
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class AuthenticatedCanActivateGuard implements CanActivate {
    constructor(private authentication: AuthenticationService, private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.authentication.isAuthenticated().then((authenticated) => {
                if (!authenticated) {
                    this.router.navigate(['/authentication']);
                    resolve(false);
                    return;
                }

                if (this.authentication.user.passwordChangeRequired) {
                    this.router.navigate(['/authentication/change-password']);
                    resolve(false);
                    return;
                }

                resolve(true);
            });
        });
    }
}

/**
 *  Guard to prevent navigation to child routes that require authentication.
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class AuthenticatedCanActivateChildGuard implements CanActivateChild {
    constructor(private authentication: AuthenticationService, private router: Router) {}

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.authentication.isAuthenticated().then((authenticated) => {
                if (!authenticated) {
                    this.router.navigate(['/authentication']);
                    resolve(false);
                    return;
                }

                if (this.authentication.user.passwordChangeRequired) {
                    this.router.navigate(['/authentication/change-password']);
                    resolve(false);
                    return;
                }

                resolve(true);
            });
        });
    }
}
